import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./TransferListSkeleton.scss";

const ITEM_COUNT = 5;

interface TransferListSkeletonProps {
  isDarkMode?: boolean;
}

const TransferListSkeleton: React.FC<TransferListSkeletonProps> = ({
  isDarkMode = false,
}) => (
  <div
    className={`transfer-list-skeleton${isDarkMode ? " transfer-list-skeleton--dark" : ""}`}
    aria-busy="true"
    aria-label="Carregando permissões"
  >
    <div className="transfer-list-skeleton__column">
      <div className="transfer-list-skeleton__header">
        <Skeleton height={13} width={84} />
        <Skeleton height={12} width={18} />
      </div>
      <Skeleton height={40} width="100%" borderRadius={16} />
      <div className="transfer-list-skeleton__card">
        {Array.from({ length: ITEM_COUNT }, (_, i) => (
          <Skeleton key={i} height={14} width={`${70 - i * 6}%`} />
        ))}
      </div>
    </div>

    <div className="transfer-list-skeleton__actions">
      <Skeleton height={32} width={32} borderRadius={8} />
      <Skeleton height={32} width={32} borderRadius={8} />
      <Skeleton height={32} width={32} borderRadius={8} />
      <Skeleton height={32} width={32} borderRadius={8} />
    </div>

    <div className="transfer-list-skeleton__column">
      <div className="transfer-list-skeleton__header">
        <Skeleton height={13} width={96} />
        <Skeleton height={12} width={18} />
      </div>
      <Skeleton height={40} width="100%" borderRadius={16} />
      <div className="transfer-list-skeleton__card">
        {Array.from({ length: ITEM_COUNT }, (_, i) => (
          <Skeleton key={i} height={14} width={`${64 - i * 5}%`} />
        ))}
      </div>
    </div>
  </div>
);

export default TransferListSkeleton;
